var map = {
	"./wiz1.jpg": 5670,
	"./wiz2.jpg": 7370,
	"./wiz3.jpg": 2492,
	"./wiz4.jpg": 8820,
	"./wiz5.jpg": 8069,
	"assets/collections/collections/Girls-just-wanna/wizerunkowa/wiz1.jpg": 5670,
	"assets/collections/collections/Girls-just-wanna/wizerunkowa/wiz2.jpg": 7370,
	"assets/collections/collections/Girls-just-wanna/wizerunkowa/wiz3.jpg": 2492,
	"assets/collections/collections/Girls-just-wanna/wizerunkowa/wiz4.jpg": 8820,
	"assets/collections/collections/Girls-just-wanna/wizerunkowa/wiz5.jpg": 8069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6422;